import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DialogAgGridSearchModule } from '../dialog-ag-grid-search/dialog-ag-grid-search.module';
import { ErrorMessageModule } from '../error-message/error-message.module';
import { TooltipMessageModule } from '../tooltip-message/tooltip-message.module';
import { NgSelectSimple } from '../utils/models/NgSelectSimple';
import { NgSelectSimpleComponent } from './ng-select-simple.component';
import { NgSelectSimpleService } from './ng-select-simple.service';



@NgModule({
  declarations: [NgSelectSimpleComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorMessageModule,
    TooltipMessageModule,
    MatTooltipModule,
    MatDialogModule,
    NgSelectModule,
    MatIconModule,
    DialogAgGridSearchModule
  ],
  exports: [NgSelectSimpleComponent],
  providers: []
})
export class NgSelectSimpleModule {

  static forRoot(ngSelectSimple: NgSelectSimple = new NgSelectSimple()): ModuleWithProviders<NgSelectSimpleModule> {
    return {
      ngModule: NgSelectSimpleModule,
      providers: [
        {provide: 'NG_SELECT_SIMPLE_VALIDATOR_MESSAGE', useValue: ngSelectSimple.validatorMessage }, 
        {provide: 'NG_SELECT_SIMPLE_TOOLTIP_MESSAGE', useValue: ngSelectSimple.tooltipMessage }, 
        {provide: 'NG_SELECT_SIMPLE_OPEN_WHEN_FOCUS', useValue: ngSelectSimple.openWhenFocus }, 
        {provide: 'NG_SELECT_SIMPLE_SEARCH_BY', useValue: ngSelectSimple.searchBy }, 
        {provide: 'NG_SELECT_SIMPLE_MARK_FIRST_ITEM', useValue: ngSelectSimple.markFirstItem }, 
        {provide: 'NG_SELECT_SIMPLE_SUBMITTED', useValue: ngSelectSimple.submitted }, 
        {provide: 'NG_SELECT_SIMPLE_SEARCHABLE', useValue: ngSelectSimple.searchable }, 
        {provide: 'NG_SELECT_SIMPLE_VALIDATOR_ALERT', useValue: ngSelectSimple.validatorAlert }, 
        {provide: 'NG_SELECT_SIMPLE_UPPER_CASE', useValue: ngSelectSimple.upperCase }, 
        {provide: 'NG_SELECT_SIMPLE_APPEND_TO', useValue: ngSelectSimple.appendTo }, 
        {provide: 'NG_SELECT_SIMPLE_LOADING_TEXT', useValue: ngSelectSimple.loadingText }, 
        {provide: 'NG_SELECT_SIMPLE_CLEAR_ALL_TEXT', useValue: ngSelectSimple.clearAllText }, 
        {provide: 'NG_SELECT_SIMPLE_MARK_FIRST', useValue: ngSelectSimple.markFirst }, 
        {provide: 'NG_SELECT_SIMPLE_CLEARABLE', useValue: ngSelectSimple.clearable }, 
        {provide: 'NG_SELECT_SIMPLE_CLEAR_ON_BACKSPACE', useValue: ngSelectSimple.clearOnBackspace }, 
        {provide: 'NG_SELECT_SIMPLE_VIRTUAL_SCROLL', useValue: ngSelectSimple.virtualScroll }, 
        {provide: 'NG_SELECT_SIMPLE_OPEN_ON_ENTER', useValue: ngSelectSimple.openOnEnter }, 
        NgSelectSimpleService
      ]
    }
  }
}
